import { arrayBufferDownload, arrayBufferDownloadExcel, downloadCSV } from "../../../../utils/download";
import { decorateEmptyGridValues, setColumnDefaultExtraProps } from "../../../../utils/table/gridUtils";
import { UPLOAD_IMAGE } from "../../../types/uploadimage.type";
import {
  FETCH_RATEADMIN_LORADJUSTMENTS_LIST,
  TOAST,
  FETCH_RATEADMIN_LORADJUSTMENTS_INIT,
  FETCH_RATEADMIN_LORADJUSTMENTS_DETAIL,
  EXPORT_RATEADMIN_LORADJUSTMENTS,
  CREATE_RATEADMIN_LORADJUSTMENTS,
  EDIT_RATEADMIN_LORADJUSTMENTS,
  INIT_CREATE_RATEADMIN_LORADJUSTMENTS_SCREEN,
  RATEADMIN_LORADJUSTMENTSDD,
  DELETE_RATEADMIN_LORADJUSTMENTS,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  RATEADMIN_LORADJUSTMENTS_SAVE_TABLE_STATE
} from "../../../types/rateadminloradjustments.type";



const formFieldValueMap = {
  id: null,
  ratePlanId: "",
  maxDays: "",
  modBy: "",
  modTime: "",
  status: 1,
  title: "",
  userId: ""
};

const INITIAL_STATE = {
  rateAdminLorAdjustmentsListview: [],
  LorAdjustmentsDD: [],
  isRateAdminLorAdjustmentsDDSuccess: false,
  isRateAdminLorAdjustmentsDDError: false,
  isLoading: false,
  error: null,
  formFieldValueMap,
  isRateAdminLorAdjustmentsCreateSuccess: false,
  isRateAdminLorAdjustmentsCreateError: false,
  isRateAdminLorAdjustmentsDetailSuccess: false,
  isRateAdminLorAdjustmentsDetailError: false,
  isRateAdminLorAdjustmentsEditSuccess: false,
  isRateAdminLorAdjustmentsEditError: false,
  isRateAdminLorAdjustmentsExportSuccess: false,
  isRateAdminLorAdjustmentsExportError: false,
  isUploadImageSuccess: false,
  isUploadImageError: false,
  imageUploadResponse: null,
  savedTableState: null
};

const tranformToGridView = (data) => {
  const rows = data.map((item) => {
    const {
      crtBy,
      crtTime,
      ratePlanTitle,
      maxDays,
      id,
      modBy,
      modTime,
      status,
      title
    } = item;

    const transformedValues = {
      crtBy,
      crtTime,
      ratePlanTitle,
      maxDays,
      id,
      modBy,
      modTime,
      status,
      title
    };
    const decoratedValues = {};
    Object.keys(transformedValues).forEach((key) => {
      decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
    });
    return decoratedValues;
  });

  const columns = [
    {
      colLabel: "ID",
      dataKey: "id",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Title",
      dataKey: "title",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Rate Plan",
      dataKey: "ratePlanTitle",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    }, {
      colLabel: "Max Days",
      dataKey: "maxDays",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },


    {
      colLabel: "Crt By",
      dataKey: "crtBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Crt Time",
      dataKey: "crtTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Mod By",
      dataKey: "modBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Edit Time",
      dataKey: "modTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Status",
      dataKey: "status",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    }
  ];

  return {
    datas: { columns, rows },
  };
};

export const rateadminLorAdjustmentsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_RATEADMIN_LORADJUSTMENTS_INIT:
      return { ...INITIAL_STATE, savedTableState: state.savedTableState, isLoadingPage: true };
    case FETCH_RATEADMIN_LORADJUSTMENTS_DETAIL.START:
    case EXPORT_RATEADMIN_LORADJUSTMENTS.START:
    case UPLOAD_IMAGE.START:
    case FETCH_RATEADMIN_LORADJUSTMENTS_LIST.START:
    case CREATE_RATEADMIN_LORADJUSTMENTS.START:
    case EDIT_RATEADMIN_LORADJUSTMENTS.START:
    case RATEADMIN_LORADJUSTMENTSDD.START:
    case DELETE_RATEADMIN_LORADJUSTMENTS.START:
      return { ...state, isLoading: true };

    case FETCH_RATEADMIN_LORADJUSTMENTS_LIST.SUCCESS: {
      const { page, data } = action.payload;

      let resetState = {
        rateAdminLorAdjustmentsListview: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        isRateAdminLorAdjustmentsCreateSuccess: false,
        isRateAdminLorAdjustmentsCreateError: false,
        savedTableState: state.savedTableState,
      };
      if (!data) {
        return resetState;
      }
      const { number, size, totalElements, totalPages } = page;
      const { datas } = tranformToGridView(data);
      return {
        ...resetState,
        rateAdminLorAdjustmentsListview: datas,
        paginationInfo: {
          pageSize: size,
          totalRecords: totalElements,
          totalPages: totalPages,
          pageNumber: number,
        },
      };
    }
    case FETCH_RATEADMIN_LORADJUSTMENTS_LIST.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        rateAdminLorAdjustmentsListview: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
        israteadminLorAdjustmentsDeletionSuccess: false,
        israteadminLorAdjustmentsDeletionError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }

    case FETCH_RATEADMIN_LORADJUSTMENTS_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
            temp[key] = action.payload[key];
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isRateAdminLorAdjustmentsDetailSuccess: true,
      };
    }
    case FETCH_RATEADMIN_LORADJUSTMENTS_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminLorAdjustmentsDetailSuccess: false,
        isRateAdminLorAdjustmentsDetailError: true,
      };
    }

    //DD
    case RATEADMIN_LORADJUSTMENTSDD.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        LorAdjustmentsDD: temp,
        isRateAdminLorAdjustmentsDDSuccess: true,
        isRateAdminLorAdjustmentsDDError: false,
      };
    }
    case RATEADMIN_LORADJUSTMENTSDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminLorAdjustmentsDDSuccess: false,
        isRateAdminLorAdjustmentsDDError: true,
      };
    }
    //END DD


    // UPLOAD_IMAGE Start
    case UPLOAD_IMAGE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isUploadImageSuccess: false,
        isUploadImageError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case UPLOAD_IMAGE.SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        imageUploadResponse: data,
        isUploadImageSuccess: true,
        isUploadImageError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // UPLOAD_IMAGE End

    // Export Start
    case EXPORT_RATEADMIN_LORADJUSTMENTS.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isRateAdminLorAdjustmentsExportSuccess: false,
        isRateAdminLorAdjustmentsExportError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case EXPORT_RATEADMIN_LORADJUSTMENTS.SUCCESS: {
      const data = action.payload;
      arrayBufferDownloadExcel(data, "lor-adjustments.xls");
      return {
        ...state,
        isRateAdminLorAdjustmentsExportSuccess: true,
        isRateAdminLorAdjustmentsExportError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // Export End

    // EDIT
    case EDIT_RATEADMIN_LORADJUSTMENTS.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminLorAdjustmentsEditSuccess: false,
        isRateAdminLorAdjustmentsEditError: true,
      };
    }

    case EDIT_RATEADMIN_LORADJUSTMENTS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isRateAdminLorAdjustmentsEditSuccess: true,
        isRateAdminLorAdjustmentsEditError: false,
      };
    }

    // EDIT END

    // Create
    case INIT_CREATE_RATEADMIN_LORADJUSTMENTS_SCREEN: {
      return { ...INITIAL_STATE, savedTableState: state.savedTableState };
    }

    case CREATE_RATEADMIN_LORADJUSTMENTS.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminLorAdjustmentsCreateSuccess: false,
        isRateAdminLorAdjustmentsCreateError: true,
      };
    }
    case CREATE_RATEADMIN_LORADJUSTMENTS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isRateAdminLorAdjustmentsCreateSuccess: true,
        isRateAdminLorAdjustmentsCreateError: false,
      };
    }

    //End


    case TOAST.RESET: {
      return {
        ...state,
        isRateAdminLorAdjustmentsCreateSuccess: false,
        isRateAdminLorAdjustmentsCreateError: false,
        isRateAdminLorAdjustmentsEditError: false,
        isRateAdminLorAdjustmentsEditSuccess: false,
        isRateAdminLorAdjustmentsDetailError: false
      };
    }

    case DELETE_RATEADMIN_LORADJUSTMENTS.SUCCESS:
      return { 
        ...state, 
        isLoading: false, 
        isRateAdminLorAdjustmentsDeleteSuccess: true, 
        isRateAdminLorAdjustmentsDeleteError: false, 
        shouldOpenDeleteConfirmationPopup: false 
      };
    case DELETE_RATEADMIN_LORADJUSTMENTS.ERROR: {
      const { error } = action.payload;
      return { 
        ...state, 
        error, 
        isLoading: false, 
        isLoading: false, 
        isRateAdminLorAdjustmentsDeleteSuccess: false, 
        isRateAdminLorAdjustmentsDeleteError: true, 
        shouldOpenDeleteConfirmationPopup: false 
      };
    }
    case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY:
      return { 
        ...state, 
        shouldOpenDeleteConfirmationPopup: action.payload, 
        isRateAdminLorAdjustmentsDeleteSuccess: false, 
        isRateAdminLorAdjustmentsDeleteError: false 
      };

    case RATEADMIN_LORADJUSTMENTS_SAVE_TABLE_STATE: {
      return {
        ...state,
        savedTableState: action.payload,
      };
    }
    default:
      return state;
  }
};
